import { createContext, useCallback, useState } from 'react';
import { genericClient } from 'usage-tracker-core/client';
import { getTrackerType, updatePublicUsageTracker } from '.';
import { jsx as _jsx } from "react/jsx-runtime";
export const TrackerContext = /*#__PURE__*/createContext({
  updateTrackerTypeIfChanged: () => {}
});
export const TrackerProvider = props => {
  const [trackerType, setTrackerType] = useState(() => {
    return getTrackerType(genericClient.getHstc());
  });
  const updateTrackerTypeIfChanged = useCallback(() => {
    const newTrackerType = getTrackerType(genericClient.getHstc());
    if (newTrackerType !== trackerType) {
      updatePublicUsageTracker();
      setTrackerType(newTrackerType);
    }
  }, [trackerType]);
  return /*#__PURE__*/_jsx(TrackerContext.Provider, {
    value: {
      updateTrackerTypeIfChanged
    },
    children: props.children
  });
};